import { Lock } from 'lucide-react';

const FEATURE_INFO: Record<string, { label: string; tier: string }> = {
  // New catalog keys (services/feature_catalog.py DEFAULT_PLAN_MATRIX)
  approvals: { label: 'Approval Chains', tier: 'Starter' },
  ap_postings: { label: 'AP Postings', tier: 'Starter' },
  org_units: { label: 'Organization Structure', tier: 'Pro' },
  approval_chains_advanced: { label: 'Advanced Approval Chains (conditional routing, escalation)', tier: 'Pro' },

  // Legacy keys still referenced by non-catalog features (mailbox, vendor portal, etc.)
  email_ingestion: { label: 'Email Ingestion', tier: 'Starter' },
  slack: { label: 'Slack Integration', tier: 'Starter' },
  teams: { label: 'Microsoft Teams Integration', tier: 'Starter' },
  google_chat: { label: 'Google Chat Integration', tier: 'Starter' },
  '3way_matching': { label: '3-Way Matching', tier: 'Pro' },
  payments: { label: 'Payment Processing', tier: 'Pro' },
  vendor_portal: { label: 'Vendor Portal', tier: 'Pro' },
  conditional_routing: { label: 'Conditional Routing', tier: 'Pro' },
  scheduled_summaries: { label: 'Scheduled Summaries', tier: 'Pro' },
};

interface UpgradeBannerProps {
  feature: string;
}

export default function UpgradeBanner({ feature }: UpgradeBannerProps) {
  const info = FEATURE_INFO[feature] ?? { label: feature, tier: 'a higher' };

  return (
    <div className="flex flex-col items-center justify-center py-20 px-6 text-center">
      <div className="w-16 h-16 rounded-2xl bg-surface-raised flex items-center justify-center mb-6">
        <Lock className="h-8 w-8 text-content-muted" />
      </div>
      <h2 className="text-xl font-semibold text-content-primary">
        Upgrade to {info.tier}
      </h2>
      <p className="mt-2 text-sm text-content-secondary max-w-md">
        {info.label} requires the {info.tier} plan or above.
        Upgrade to unlock this feature and more.
      </p>
      <div className="mt-6 flex items-center gap-3">
        <a
          href="https://ez-flow.io/pricing"
          target="_blank"
          rel="noopener noreferrer"
          className="px-4 py-2 rounded-lg bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors"
        >
          Upgrade Now
        </a>
        <a
          href="https://ez-flow.io/pricing"
          target="_blank"
          rel="noopener noreferrer"
          className="px-4 py-2 rounded-lg border border-border-default text-content-secondary text-sm font-medium hover:bg-surface-raised transition-colors"
        >
          Learn More
        </a>
      </div>
    </div>
  );
}
